import type { Booking } from "@common/types";

interface EditPayload {
  newDate: string;
  newTimeSlot?: string;
  customStartTime?: string;
  numberOfGuests?: number;
  tripId?: string;
  departureLocationId?: string | null;
  partnerId?: string;
}

/**
 * Does the edit change something the guest sees or plans around (day, time, trip, guests, departure place)?
 * Only then is the admin asked whether to send an update notice; a note or an internal reference needs no notice.
 */
export function changesWhatGuestSees(payload: EditPayload, booking: Booking): boolean {
  return (
    payload.newDate !== booking.date ||
    (payload.newTimeSlot !== undefined && payload.newTimeSlot !== booking.timeSlot) ||
    (payload.customStartTime ?? undefined) !== (booking.customStartTime ?? undefined) ||
    (payload.numberOfGuests !== undefined && payload.numberOfGuests !== booking.numberOfGuests) ||
    (payload.tripId !== undefined && payload.tripId !== booking.tripId) ||
    payload.departureLocationId !== undefined
  );
}
